import VolumeOff from '../../src/legacy/VolumeOff.tsx';
export default VolumeOff;
